export default "__VITE_ASSET__dHI_dzDz__"